module.exports = __webpack_public_path__ + "img/cooperation12.cef3907a.png";